/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */

// Lib dependencies
import { useTranslation } from 'react-i18next';

// UI lib components
import { Badge } from '@mantine/core';

// Types
import { QuestionPriority } from '@app/types/blackroom-api';
import { PriorityBadge, QuestionPriorityBadgeProps } from './type';

// Style
import { palette } from '@app/shared/ui-kit/colors';

// Constants
const PRIORITY_BADGE: PriorityBadge = {
  [QuestionPriority.Low]: {
    color: palette.blackroomGreen,
    labelKey: 'Support:Common.priorities.low',
  },
  [QuestionPriority.Medium]: {
    color: palette.blackroomOrange,
    labelKey: 'Support:Common.priorities.medium',
  },
  [QuestionPriority.High]: {
    color: palette.blackroomRed,
    labelKey: 'Support:Common.priorities.high',
  },
};

/* -------------------------------------------------------------------------- */
/*                                 Components                                 */
/* -------------------------------------------------------------------------- */

function QuestionPriorityBadge({
  questionPriority,
  ...props
}: QuestionPriorityBadgeProps) {
  /* ********************************** HOOKS ********************************* */

  // Localization
  const { t } = useTranslation(['Support']);

  /* ***************************** LOCAL VARIABLES **************************** */

  const periorityBadge = PRIORITY_BADGE[questionPriority];

  /* ******************************** RENDERING ******************************* */
  return (
    <Badge color={periorityBadge.color} {...props}>
      {t(periorityBadge.labelKey)}
    </Badge>
  );
}

export default QuestionPriorityBadge;
